 $('.slider').slick({
            autoplay: true,         //自動再生
            autoplaySpeed: 5000,
            dots: true,             //ドット
            infinite: true,         //ループ
            pauseOnHover: false,    //ホバーで止めない
            centerMode:true,        //両サイドを表示
            centerPadding:"25%",    //両サイドをどれぐらい表示するか
        })
  function initSlider() {
            $(".slider").slick("unslick"); // 一旦スライダーを解除
            let isMobile = window.innerWidth <= 768;
            $(".slider").slick({
                autoplay: true,
                autoplaySpeed: 5000,
                dots: true,
                infinite: true,
                pauseOnHover: false,
                centerMode: !isMobile, // 1040px以下では無効
                centerPadding: isMobile ? "0" : "23%", // 余白を調整
            });
        }

        $(document).ready(function () {
            initSlider();
            $(window).resize(function () {
                initSlider(); // 画面サイズが変わるたびに更新
            });
        });
